import { RichTextDisplay } from "@tellescope/ui";
import type { ChatMessage } from "@tellescope/types-models";
import { formatDateTime } from "@tellescope/utils";
import { AttachmentIndicator } from "./AttachmentIndicator";

interface MessageBubbleProps {
  message: ChatMessage;
  isOwnMessage: boolean;
}

export const MessageBubble = ({ message, isOwnMessage }: MessageBubbleProps) => (
  <div className={`flex ${isOwnMessage ? "justify-end" : "justify-start"} mb-3`}>
    <div
      className={`max-w-[80%] rounded-2xl px-4 py-2 ${
        isOwnMessage ? "bg-primary text-primary-foreground rounded-br-md" : "bg-muted rounded-bl-md"
      }`}
    >
      {message.html ? (
        <RichTextDisplay key={message.id} content={message.html} className="text-sm" />
      ) : (
        <p className="text-sm whitespace-pre-wrap">{message.message}</p>
      )}

      {message.attachments && message.attachments.length > 0 && (
        <AttachmentIndicator count={message.attachments.length} />
      )}

      <p className={`text-xs mt-1 ${isOwnMessage ? "text-primary-foreground/70" : "text-muted-foreground"}`}>
        {formatDateTime(message.timestamp || message.updatedAt, "MMM D, YYYY at hh:mm a", true)}
      </p>
    </div>
  </div>
);
